import { useEffect } from 'react';
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';

/**
 * StylesAppLoader
 *
 * Componente para cargar y aplicar variables de estilo CSS globales en `:root` a partir de un archivo
 * de configuración (`config.json`). Las variables definidas en `STYLES_APP` dentro de `config.json`
 * se aplicarán como estilos globales accesibles en cualquier archivo CSS de la aplicación.
 *
 * @component
 * @returns {null} Este componente no renderiza nada en la interfaz.
 * @author Eva
 */
function StylesAppLoader() {

  const { config } = useGlobalVariablesContext();

  const styles = config.STYLES_APP
  useEffect(() => {
    for (const [key, value] of Object.entries(styles)) {
      document.documentElement.style.setProperty(`--${key}`, value);
    }
  }, []);

  return null;
};

export default StylesAppLoader;
